import { useIntl } from 'react-intl'

import type { TagEditorProps } from './TagEditor.types'
import { DEFAULT_TAG_COLOR, MAX_TAG_NAME_LENGTH } from './tagging.constants'
import { tagColorBorder, tagColorToHex } from './tagging.utils'
import { useTagging } from './useTagging'

export const TagEditor = (props: TagEditorProps) => {
  const { ariaLabel, disabled, onExit } = props
  const intl = useIntl()
  const tagging = useTagging()

  const isDefaultColor = tagging.selectedColor === DEFAULT_TAG_COLOR
  const bgColor = isDefaultColor ? '#ffffff' : tagColorToHex(tagging.selectedColor)
  const borderColor = isDefaultColor ? '#ced4da' : tagColorBorder(tagging.selectedColor)

  return (
    <span
      className="TagPill TagEditor"
      style={{
        backgroundColor: bgColor,
        borderColor,
      }}
    >
      {/* eslint-disable jsx-a11y/no-autofocus -- editor must focus on open */}
      <input
        ref={tagging.inputRef}
        aria-label={ariaLabel}
        autoFocus
        className="TagEditor-input"
        disabled={disabled}
        maxLength={MAX_TAG_NAME_LENGTH}
        onChange={e => tagging.setInputText(e.target.value)}
        placeholder=""
        type="text"
        value={tagging.inputText}
      />
      {/* eslint-enable jsx-a11y/no-autofocus */}
      <button
        aria-label={intl.formatMessage({ id: 'Tags_close_editor' })}
        className="TagEditor-close"
        disabled={disabled}
        onClick={onExit}
        type="button"
      >
        &#x2715;
      </button>
    </span>
  )
}
